import { useEffect, useState } from "react";
import { CommunityTagModel } from "../models/CommunityTagModel";
import { CommunityTagItem } from "./CommunityTagItem";
import { CommunitySuggestList } from "./CommunitySuggestList";
import { CommunityOptionList } from "./CommunityOptionList";



type Props = {
    title: string;
    description: string;
    options?: CommunityTagModel[];
    value: CommunityTagModel[];
    onChange: (value: CommunityTagModel[]) => void;
    onChangeInput?: (value: string) => void;
    tagsClassName?: string;
    placeholder?: string;
    limit?: number;
    suggests?: string[];
}

export const CommunityTagInput = ({ title, description, options, value, onChange, onChangeInput, tagsClassName, placeholder, limit, suggests }: Props) => {
    const [type, setType] = useState("");
    const [list, setList] = useState(options);
    const [showOpts, setShowOpts] = useState(false);
    // const filteredOptions = useMemo(() => !list ? []: list.filter(p => p.label.toLowerCase().includes(type.toLowerCase())), [list, type]);

    useEffect(() => {
        onChangeInput?.(type);
    }, [type]);

    useEffect(() => {
        setList(options);
    }, [options]);

    const _onChangeValues = (values: CommunityTagModel[]) => {
        if(limit && values.length >= limit)
            return;
        onChange(values);
        if(!!list) {
            setList(() => options && options.filter(p => !values.includes(p)))
        }
    }

    const _handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setType(e.target.value);

        if(!showOpts)
            setShowOpts(true);
    }

    const _handleSelectOpt = (opt: CommunityTagModel) => {
        if(!!value.find(v => v.value === opt.value)) // no duplicate
            return;
        setShowOpts(false);
        let _value = [...value];
        _value.push(opt);
        _onChangeValues(_value);
        setType("");
    }

    const _addTypingTag = (inputValue: string) => {
        if(!!value.find(v => v.label.toLowerCase() === inputValue.toLowerCase())) // no duplicate
            return;
        let _value = [...value];
        const _tagValue = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
        _value.push({ label: _tagValue, value: _tagValue });
        _onChangeValues(_value);
        setType("");

    }
    
    const _handleOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key !== "Enter") return;
        e.preventDefault();
        e.stopPropagation();

        const _inputValue = e.currentTarget.value;
        if(_inputValue.length <= 0)
            return;

        if(!!list) {
            const _search = list?.filter(f => f.label.toLowerCase().includes(_inputValue.toLowerCase()));
            if(_search.length === 1) {
                _handleSelectOpt(_search[0]);
            }
            return;
        }
        
        if(!!suggests) {
            const _unique = suggests.filter(s => s.toLowerCase().includes(_inputValue.toLowerCase()) && s.toLowerCase().startsWith(_inputValue.toLowerCase()));
            if(_unique.length === 1) 
                _addTypingTag(_unique[0]);
        }
    }

    return (
        <div className="community-tag-wrapper">
            <div className="community-tag-input">
                <div className="info">
                    <span className="title">{title}</span>
                    <span className="description">{description}</span>
                </div>
                <div className="tags-value">
                    {value && value?.map((t, i) => (
                        <CommunityTagItem
                            onRemove={() => _onChangeValues(value.filter(v => v !== t))}
                            value={t} 
                            className={tagsClassName} 
                            key={i}
                        />
                    ))}

                    <input
                        type="text"
                        value={type}
                        placeholder={placeholder}
                        onChange={_handleOnChange}  
                        onKeyDown={_handleOnKeyDown}
                        onFocus={() => { setShowOpts(true); setList(options || []); }}
                        onBlur={() => setShowOpts(false)}
                    />
                </div>
            </div>
            {showOpts && (
                <>
                    {list && list.length > 0 ? (
                        <CommunityOptionList
                            options={list}
                            onSelect={_handleSelectOpt}
                        />
                    ) : (
                        suggests && (
                            <CommunitySuggestList
                                values={value}
                                suggests={suggests}
                                typeValue={type}
                                onSelect={_addTypingTag}
                            />
                        )
                    )}
                </>
            )}
        </div>
    )
}